import { FETCH_XBK_CONFIG } from '../constants';

export default function runtime(state = {}, action) {
  switch (action.type) {
    case FETCH_XBK_CONFIG:
      return { download: action.download }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/download.js